import { createTrendServices } from "./trendServices";

export const COST_PAGES = [
  { label: "Visão Geral", path: "visao-geral" },
  { label: "Desvios", path: "desvios" },
  { label: "Tendência", path: "tendencia" },
  { label: "Prazos", path: "prazos" },
  { label: "Estoque e Compras", path: "estoque-compras/controle" },
  { label: "Mão de Obra", path: "mao-de-obra" },
  { label: "Causas e Ações", path: "causas-acoes" },
  { label: "Comparativo Obras", path: "comparativo-obras" },
];

export const MOCK_PROJECTS = [
  { id: "horizonte", name: "Horizonte do Mediterrâneo", type: "Residencial" },
  { id: "jardim", name: "Parque das Oliveiras", type: "Residencial" },
];

export const MOCK_CLOSINGS = [
  { id: "2026-08", label: "Ago/2026", month: "Ago/26" },
  { id: "2026-07", label: "Jul/2026", month: "Jul/26" },
];

const HORIZONTE_GROUPS = [
  ["Instalações", "Elétrica — infraestrutura de prumadas", 5.18, 2.2, 1.0, 2.90, "Reajuste de preço unitário", "Material"],
  ["Edifício Garagem", "Impermeabilização de lajes", 3.58, 1.6, 0.7, 2.06, "Retrabalho", "Serviço"],
  ["Área Comum", "Paisagismo e irrigação", 2.09, 1.3, 0.4, 0.90, "Item não orçado", "Serviço"],
  ["Outros grupos", "Logística e frete de materiais", 3.25, 1.4, 0.8, 1.43, "Aumento de quantidade", "Material"],
  ["Apoio de Obra", "Canteiro — locação de contêineres", 2.85, 0.6, 0.6, 2.00, "Extensão de prazo", "Equipamento"],
  ["Equipamentos", "Locação de equipamentos", 1.47, 0.1, 0.3, 1.13, "Economia de contrato", "Equipamento"],
  ["Estrutura", "Estrutura de concreto armado", 12.24, 8.3, 2.6, 1.22, "Produtividade acima do previsto", "Mão de obra"],
  ["Obra Bruta", "Alvenaria e contrapiso", 6.38, 2.2, 1.2, 2.60, "Redução de perdas", "Material"],
  ["Acabamentos", "Revestimentos e pintura", 14.42, 4.5, 4.24, 5.26, "Reajuste de preço unitário", "Material"],
  ["Fundação", "Fundações e contenções", 3.46, 2.09, 1.0, 0.37, "Economia de quantidade", "Serviço"],
];

function createServices(rows, prefix, budgetFactor = 1, costFactor = 1) {
  return createTrendServices(rows, HORIZONTE_GROUPS, prefix, budgetFactor, costFactor);
}

const JULY_GROUPS = HORIZONTE_GROUPS.map((row) => [...row]);
JULY_GROUPS.forEach((row, index) => {
  row[3] = Number((row[3] * 0.96).toFixed(2));
  row[4] = Number((row[4] * 1.04).toFixed(2));
  row[5] = Number((row[5] * 1.0044).toFixed(2));
});

const JARDIM_GROUPS = HORIZONTE_GROUPS.map((row) => [...row]);
JARDIM_GROUPS.forEach((row) => {
  row[2] = Number((row[2] * 0.72).toFixed(2));
  row[3] = Number((row[3] * 0.62).toFixed(2));
  row[4] = Number((row[4] * 0.68).toFixed(2));
  row[5] = Number((row[5] * 0.58).toFixed(2));
});

export const MOCK_SCENARIOS = {
  "horizonte:2026-08": {
    budgetOriginal: 53.4,
    approvedChanges: 1.52,
    services: createServices(HORIZONTE_GROUPS, "hz"),
    executiveReference: 57.32,
    physicalPlanned: 45.2,
    physicalActual: 43.1,
    start: "Jan/25",
    forecastFinish: "Out/27",
  },
  "horizonte:2026-07": {
    budgetOriginal: 53.4,
    approvedChanges: 1.52,
    services: createServices(JULY_GROUPS, "hz-jul"),
    physicalPlanned: 43.4,
    physicalActual: 41.8,
    start: "Jan/25",
    forecastFinish: "Nov/27",
  },
  "jardim:2026-08": {
    budgetOriginal: 38.73,
    approvedChanges: 0.8,
    services: createServices(JARDIM_GROUPS, "jd"),
    physicalPlanned: 51.4,
    physicalActual: 52.6,
    start: "Mar/25",
    forecastFinish: "Jun/27",
  },
  "jardim:2026-07": {
    budgetOriginal: 38.73,
    approvedChanges: 0.8,
    services: createServices(JULY_GROUPS, "jd-jul", 0.72, 0.67),
    physicalPlanned: 49.2,
    physicalActual: 50.8,
    start: "Mar/25",
    forecastFinish: "Jul/27",
  },
};

export const INITIAL_ACTIONS = [
  { id: "act-1", serviceId: "hz-1", cause: "Reajuste de preço unitário", notes: "Validar a nova tabela de cabos e negociar preço para o saldo.", action: "Renegociar contrato e travar o preço do saldo", owner: "C. Andrade", due: "2026-09-26", investigation: "Concluída", execution: "Atrasada", expectedImpact: 0.18, provenImpact: null },
  { id: "act-2", serviceId: "hz-2", cause: "Retrabalho", notes: "Inspecionar a impermeabilização do subsolo antes de fechar a próxima frente.", action: "Solicitar laudo técnico e cobrar garantia do fornecedor", owner: "R. Menezes", due: "2026-10-02", investigation: "Em andamento", execution: "Não iniciada", expectedImpact: 0.22, provenImpact: null },
  { id: "act-3", serviceId: "hz-3", cause: "Item não orçado", notes: "Ajustar o escopo de irrigação conforme revisão do paisagismo.", action: "Apresentar aditivo com escopo revisado", owner: "J. Tavares", due: "2026-10-08", investigation: "Concluída", execution: "Em execução", expectedImpact: 0.12, provenImpact: 0.05 },
  { id: "act-4", serviceId: "hz-4", cause: "Aumento de quantidade", notes: "Conferir quantitativos e entregas parciais de frete.", action: "Revisar quantitativo logístico e renegociar tabela", owner: "P. Lima", due: "2026-10-15", investigation: "Em andamento", execution: "Em execução", expectedImpact: 0.08, provenImpact: null },
];

// Valor agregado acumulado antes de Jan/26, em R$ milhões.
export const MOCK_AGGREGATE_OPENING = 10.9;

export const MOCK_MONTHLY = [
  { month: "Jan/26", incurred: 1.2, committed: 0, estimate: 0, aggregate: 12.1 },
  { month: "Fev/26", incurred: 1.3, committed: 0, estimate: 0, aggregate: 13.5 },
  { month: "Mar/26", incurred: 1.6, committed: 0, estimate: 0, aggregate: 15.1 },
  { month: "Abr/26", incurred: 1.7, committed: 0, estimate: 0, aggregate: 16.7 },
  { month: "Mai/26", incurred: 1.5, committed: 0, estimate: 0, aggregate: 18.2 },
  { month: "Jun/26", incurred: 1.4, committed: 0, estimate: 0, aggregate: 19.5 },
  { month: "Jul/26", incurred: 1.3, committed: 0, estimate: 0, aggregate: 22.0 },
  { month: "Ago/26", incurred: 1.7, committed: 0, estimate: 0, aggregate: 24.29 },
  { month: "Set/26", incurred: 0, committed: 1.0, estimate: 1.2, aggregate: 26.49 },
  { month: "Out/26", incurred: 0, committed: 0.9, estimate: 1.4, aggregate: 28.79 },
  { month: "Nov/26", incurred: 0, committed: 0.8, estimate: 1.7, aggregate: 31.29 },
  { month: "Dez/26", incurred: 0, committed: 0.7, estimate: 1.8, aggregate: 33.79 },
];

export const MOCK_CAUSES = [
  "Reajuste de preço unitário",
  "Retrabalho",
  "Item não orçado / escopo novo",
  "Aumento de quantidade",
  "Produtividade abaixo do previsto",
  "Extensão de prazo",
  "Redução de perdas",
  "Economia de contrato",
];

export const MOCK_ORDERS = [
  { id: "PC-2841", package: "Cerâmica", supplier: "Revestir Distribuidora", value: 0.24, expected: "2026-10-02", confirmed: "2026-10-02", status: "Confirmado" },
  { id: "PC-2863", package: "Instalações", supplier: "Elevo Norte", value: 0.41, expected: "2026-09-28", confirmed: "2026-10-05", status: "Reprogramado" },
  { id: "PC-2802", package: "Drywall", supplier: "Placa Forte", value: 0.18, expected: "2026-09-12", confirmed: "2026-09-30", status: "Atrasado" },
  { id: "PC-2790", package: "Esquadrias", supplier: "Alumínio Sul", value: 0.32, expected: "2026-09-08", confirmed: "Não informado", status: "Sem confirmação" },
  { id: "PC-2894", package: "Instalações", supplier: "Hidro Macau", value: 0.16, expected: "2026-10-14", confirmed: "2026-10-14", status: "Confirmado" },
];

export const MOCK_INVENTORY = [
  { item: "Porcelanato 90x90", package: "Louças / Cerâmica", stock: 214, inTransit: 0, demand: 96, coverage: 74, leadTime: 30, status: "Excesso" },
  { item: "Cabo flexível 2,5 mm²", package: "Instalações", stock: 72, inTransit: 18, demand: 96, coverage: 23, leadTime: 21, status: "Comprar" },
  { item: "Argamassa AC-III", package: "Cerâmica", stock: 118, inTransit: 60, demand: 84, coverage: 51, leadTime: 14, status: "Coberto" },
  { item: "Placa de drywall ST", package: "Drywall", stock: 96, inTransit: 0, demand: 74, coverage: 9, leadTime: 18, status: "Ruptura próxima" },
  { item: "Perfil de alumínio", package: "Esquadrias", stock: 186, inTransit: 0, demand: 72, coverage: 96, leadTime: 60, status: "Parado" },
];
